import { Grid, SkeletonLine, pxToRem, useStyles } from '@archipro-design/aria';
import * as S from './ArticleTileSkeleton.mobile.style';

export const ArticleTileSkeletonMobile = () => {
    const { css } = useStyles();

    return (
        <Grid columns={`${pxToRem(130)} 1fr`}>
            <SkeletonLine width={pxToRem(125)} height={pxToRem(125)} />
            <div>
                <SkeletonLine
                    width={'90%'}
                    height={pxToRem(25)}
                    className={css(S.SkeletonTitleFirstLineMobile)}
                />
                <SkeletonLine
                    width={'70%'}
                    height={pxToRem(25)}
                    className={css(S.SkeletonTitleSecondLineMobile)}
                />
                <SkeletonLine
                    width={pxToRem(160)}
                    height={pxToRem(15)}
                    className={css(S.SkeletonSubheadingFirstLineMobile)}
                />
                <SkeletonLine width={pxToRem(170)} height={pxToRem(15)} />
            </div>
        </Grid>
    );
};
